import { ReactNode, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { GuestModeBanner } from "@/components/GuestModeBanner";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const [showGuestBanner, setShowGuestBanner] = useState(true);

  if (isLoading) {
    return (
      <div className="min-h-screen mystical-background mystical-pattern flex items-center justify-center">
        <div className="text-center space-y-4">
          <LoadingSpinner size="lg" />
          <p className="text-muted-foreground">Loading your journey...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  const isAnonymous = user?.is_anonymous === true;

  return (
    <TooltipProvider>
      {isAnonymous && showGuestBanner && (
        <GuestModeBanner onDismiss={() => setShowGuestBanner(false)} />
      )}
      {children}
    </TooltipProvider>
  );
};
